import * as React from 'react'
import {translateCountryName} from "@ui-seeker/utils"

import {LabelCountry} from '@components'

export default function retailerColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'siteName', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country }) => {
				return <LabelCountry country={country} label={value} />
			}
        }
    }]
}
